"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryGameMembershipRepository = InMemoryGameMembershipRepository;
function InMemoryGameMembershipRepository() {
    const _repo = {};
    return {
        getPlayerIdFor(gameId) {
            return _repo[gameId] || null;
        },
        savePlayerIdFor(gameId, playerId) {
            _repo[gameId] = playerId;
        },
    };
}
